import { ReactNode, useMemo } from "react";
import { LoadingStatus } from "src/libs/fetcher";
import { useCardThemed } from "./useCardThemed";
import {
  getCardThemeButtonColors,
  CardThemeIdentifier,
} from "./card-theme-utils";

type ThemeBadgeVariant = "primary" | "secondary";

export type ThemeBadgeProps = {
  themeId?: CardThemeIdentifier;
  variant?: ThemeBadgeVariant;
  children: ReactNode;
};

export function ThemeBadge({
  themeId,
  variant = "primary",
  children,
}: ThemeBadgeProps) {
  const { theme, status } = useCardThemed(themeId);

  const colors = useMemo(() => {
    if (variant === "primary") {
      return getCardThemeButtonColors(theme.buttonPrimary);
    } else {
      return getCardThemeButtonColors(theme.buttonSecondary);
    }
  }, [variant, theme]);

  if (status !== LoadingStatus.SUCCESS) {
    return null;
  }

  return (
    <div
      className="inline-block rounded-l-full rounded-r-full border px-4 py-2 text-sm font-medium"
      style={{
        backgroundColor: colors.default.backgroundColor,
        color: colors.default.textColor,
        borderColor:
          colors.default.borderColor || colors.default.backgroundColor,
      }}
    >
      {children}
    </div>
  );
}
